<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <b-card>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Tambah Pengguna
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <b-form class="mt-2">
      <b-row>
        <b-col sm="12">
          <b-form-group
            label="Nama"
            label-for="account-name"
          >
            <b-form-input
              v-model="userData.nama"
              name="name"
              placeholder="Name"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="E-mail"
            label-for="account-e-mail"
          >
            <b-form-input
              v-model="userData.email"
              name="email"
              placeholder="Email"
            />

          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Password"
            label-for="password"
          >
            <b-form-input
              v-model="userData.password"
              name="password"
              placeholder="Password"
              type="password"
            />

          </b-form-group>
        </b-col>
        <b-col sm="12" v-if="userData.role == '3d39e290e33d3590f10799' || userData.role == '1921bdf217e8fd3qsd173as'">
          <b-form-group
            label="NIP"
            label-for="nip"
          >
            <b-form-input
              v-model="userData.nip"
              name="nip"
              placeholder="NIP"
            />
          </b-form-group>
        </b-col>
       <b-col sm="12">
          <label>Hak Akses</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="userData.role"
            :options="role"
            class="w-100"
            :reduce="val => val.value"
          />
        </b-col>
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpanData"
          >
            Simpan
          </b-button>
        </b-col>
        <b-col cols="12">
          <center v-if="loading == 1"><b-spinner label="Spinning"></b-spinner></center>
        </b-col>
      </b-row>
    </b-form>
      </b-card>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BRow, BCol,BCard, BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/connection-api/data/other/countries'
import store from '@/store'
import {
  postPengguna,
} from '@/connection-api/master'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    role: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: 0,
      userData: {},
      required,
      alphaNum,
      email,
      countries,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
      proyekOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Semua' },
        ],
      },
    }
  },
  methods: {
    simpanData() {
      this.loading = 1
       postPengguna(this.userData)
      .then(response => {
       if (response.data.success === true) {
        this.loading = 0
        this.makeToast('success', 'Data berhasil disimpan.')
        this.$emit('refetchData')
      } else {
        this.loading = 0
        this.makeToast('danger', response.data.message)
      }
      })
      .catch(error => console.log(error));
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Akses Pengguna',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
